/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Progress_Report_Exercises_EmptyInputs */

const en_us2_progress_report_exercises_empty = /** @type {(inputs: Progress_Report_Exercises_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`No exercise with a load or reps this week.`);
	return /** @type {LocalizedString} */ (`No exercise with a load or reps this month.`)
	
};

const pt_br2_progress_report_exercises_empty = /** @type {(inputs: Progress_Report_Exercises_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nenhum exercício com carga ou repetições nesta semana.`);
	return /** @type {LocalizedString} */ (`Nenhum exercício com carga ou repetições neste mês.`)
	
};

const es_419_progress_report_exercises_empty = /** @type {(inputs: Progress_Report_Exercises_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Ningún ejercicio con peso o repeticiones esta semana.`);
	return /** @type {LocalizedString} */ (`Ningún ejercicio con peso o repeticiones este mes.`)
	
};

const pt_pt2_progress_report_exercises_empty = /** @type {(inputs: Progress_Report_Exercises_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nenhum exercício com carga ou repetições nesta semana.`);
	return /** @type {LocalizedString} */ (`Nenhum exercício com carga ou repetições neste mês.`)
	
};

const fr_fr2_progress_report_exercises_empty = /** @type {(inputs: Progress_Report_Exercises_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Aucun exercice avec charge ou répétitions cette semaine.`);
	return /** @type {LocalizedString} */ (`Aucun exercice avec charge ou répétitions ce mois-ci.`)
	
};

const de_de2_progress_report_exercises_empty = /** @type {(inputs: Progress_Report_Exercises_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Keine Übung mit Gewicht oder Wdh. diese Woche.`);
	return /** @type {LocalizedString} */ (`Keine Übung mit Gewicht oder Wdh. diesen Monat.`)
	
};

const it_it2_progress_report_exercises_empty = /** @type {(inputs: Progress_Report_Exercises_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nessun esercizio con carico o ripetizioni questa settimana.`);
	return /** @type {LocalizedString} */ (`Nessun esercizio con carico o ripetizioni questo mese.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "week" | "No exercise with a load or reps this week." |
* | * | "No exercise with a load or reps this month." |
*
* @param {Progress_Report_Exercises_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_exercises_empty = /** @type {((inputs: Progress_Report_Exercises_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Exercises_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_exercises_empty(inputs)
	if (locale === "es-419") return es_419_progress_report_exercises_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_exercises_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_exercises_empty(inputs)
	if (locale === "de-DE") return de_de2_progress_report_exercises_empty(inputs)
	if (locale === "it-IT") return it_it2_progress_report_exercises_empty(inputs)
	return en_us2_progress_report_exercises_empty(inputs)
});
export { progress_report_exercises_empty as "progress-report.exercises_empty" }